<div class="Notice" [attr.data-kind]="data.kind || 'error'">
  <h2 mat-dialog-title class="Notice__title">
    <mat-icon>{{ icon }}</mat-icon>
    {{ data.title }}
  </h2>

  <mat-dialog-content>
    <!-- Preserves the line breaks the caller sent; label warnings arrive one
         per line and run together otherwise. -->
    <p class="Notice__message">{{ data.message }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" mat-dialog-close cdkFocusInitial>
      {{ 'close' | translate }}
    </button>
  </mat-dialog-actions>
</div>
